import { render } from "./OrcamentosLiberados.vue?vue&type=template&id=9c728aea&scoped=true"
import script from "./OrcamentosLiberados.vue?vue&type=script&lang=js"
export * from "./OrcamentosLiberados.vue?vue&type=script&lang=js"

import "./OrcamentosLiberados.vue?vue&type=style&index=0&id=9c728aea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c728aea"]])

export default __exports__